import { api } from "api/api";
import { AxiosError } from "axios";
import MarcaVeiculo from "model/gestao/frotas/MarcaVeiculo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class MarcaVeiculoService implements BaseServiceCadastros<MarcaVeiculo> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/marcaVeiculo/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<MarcaVeiculo>((resolve, reject): void => {
            api
                .get(`/marcaVeiculo/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(marcaVeiculo: MarcaVeiculo) {
        return new Promise<MarcaVeiculo>((resolve, reject): void => {
            api
                .post(`/marcaVeiculo/incluir`, JSON.stringify(marcaVeiculo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(marcaVeiculo: MarcaVeiculo) {
        return new Promise<MarcaVeiculo>((resolve, reject): void => {
            api
                .put(`/marcaVeiculo/editar`, JSON.stringify(marcaVeiculo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/marcaVeiculo/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default MarcaVeiculoService;